import { render, staticRenderFns } from "./AmbassadorDetail.vue?vue&type=template&id=74f36e82&scoped=true"
import script from "./AmbassadorDetail.vue?vue&type=script&lang=js"
export * from "./AmbassadorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f36e82",
  null
  
)

export default component.exports